import React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import styles from './SocialEmptyListState.scss';

export interface SocialEmptyListStateProps extends InjectedTranslateProps {}

const SocialEmptyListState: React.FunctionComponent<SocialEmptyListStateProps> = ({
  t,
}) => (
  <div className={styles.emptyState}>
    <div data-hook="primary-text" className={styles.primaryText}>
      {t('chatroom-list.empty-state.primary-text')}
    </div>
    <div data-hook="secondary-text" className={styles.secondaryText}>
      {t('chatroom-list.empty-state.secondary-text')}
    </div>
  </div>
);

export default translate()(SocialEmptyListState);
